import angular from 'angular';
import UpdateProfileController from './update-profile.controller';
import UpdateEmailController from './update-email.controller';
import UpdatePasswordController from './update-password.controller';
import UpdatePointOfServiceController from './update-point-of-service.controller';
import OrderHistoryController from './order-history.controller';
import UpdateNewsletterController from './update-newsletter.controller';
import CloseAccountController from './close-account.controller';

let account = angular
    .module('account', [])
    .controller('UpdateProfileController', UpdateProfileController)
    .controller('UpdateEmailController', UpdateEmailController)
    .controller('UpdatePasswordController', UpdatePasswordController)
    .controller('UpdateNewsletterController', UpdateNewsletterController)
    .controller('UpdatePointOfServiceController', UpdatePointOfServiceController)
    .controller('OrderHistoryController', OrderHistoryController)
    .controller('CloseAccountController', CloseAccountController);
export default account;
